import React from "react";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      groupUser: this.props.groupUser,
    };
  },
  onError() {
    var updated = this.state.groupUser;
    updated.user.avatar_thumb = "/images/ja2/img_noimage.gif";
    this.setState({
      groupUser: updated,
    });
  },
  fullname_disp(user){
    if (user.is_fullname_hidden && user.is_verified_identity){
      return `@${user.tunagate_id}(本人確認済)`;
    }
    else if (!user.is_fullname_hidden && user.is_verified_identity){
      return  `${user.familyname} ${user.firstname}(本人確認済)`
    }
    else{
      return `${user.familyname} ${user.firstname}`
    }
  },
  render() {
    // var updatedAt = this.state.groupUser.formatted_updated_at;
    var userDisp = (
      <div>
        <div className="icon-type1">
          <img alt="Img noimage" src="/images/ja2/img_noimage.gif" />
        </div>
        <span className="txt-member">退会ユーザー</span>
      </div>
    );

    if (this.props.index < 4 && this.state.groupUser.user) {
      var hasAppIcon = "";
      if (this.state.groupUser.user.has_app) {
        hasAppIcon = (
          <span
            className="glyphicon glyphicon-phone"
            aria-hidden="true"
            style={{ fontSize: "0.8em", color: "#1ed45d" }}
          />
        );
      }
      if (this.state.groupUser.user.id == this.props.currentUserId) {
        userDisp = "";
      } else {
        userDisp = (
          <div style={{ display: "flex" }}>
            <div className="icon-type1">
              <img
                data-src={this.state.groupUser.user.avatar_thumb}
                onError={this.onError}
                className="lazyload rounded-circle member-icon_48px"
                alt=""
              />
            </div>
            <span className="txt-member">
              &nbsp;{this.fullname_disp(this.state.groupUser.user)}{" "}
              {this.state.groupUser.user.firstname} {hasAppIcon}
            </span>
          </div>
        );
      }
    } else {
      userDisp = "";
    }

    return (
      <div style={{ display: "flexbox", flexDirection: "row" }}>{userDisp}</div>
    );
  },
});
